import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { RetailerComponent } from './pages/retailer/retailer.component';
import { RetailerRoutingModule } from './retailers.routes';
import { TableRetailersComponent } from './components/table-retailers/table-retailers.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ManageRetailerDialogComponent } from './components/manage-retailer-dialog/manage-retailer-dialog.component';

const Materials = [MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule];

@NgModule({
  declarations: [RetailerComponent, TableRetailersComponent, ManageRetailerDialogComponent],
  imports: [
    FormsModule,
    SharedModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    RetailerRoutingModule,
    Materials,
  ],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RetailersModule {}
